import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";
import "./BigPic.scss";
import "../ComponentCarousel/AllForCarousel.scss";
import {
  clearAllBodyScrollLocks,
  disableBodyScroll,
  enableBodyScroll,
} from "body-scroll-lock";
import BigPicMain, { BigPicHeader } from "./BigPicMain";
import {
  debounce,
  formatSize,
  getWatermarks,
  isWeb,
  isWeixinWeb,
  getPageSameType,
} from "../../utils/util";
import Danmaku from "../Comment/Danmaku";
import Switch from "../Switch";
import intl from "react-intl-universal";
import useDanmakuSwitch from "./useDanmakuSwitch";
import MayBeOneImg from "../Me/MayBeOneImg";
import imageUtil from "../../utils/image";
import LazyLoad from "react-lazyload";
import { IImageMayBe } from "../../global";
import { IComponent } from "../../component";
import classNames from "classnames";
import ReactSVG from "react-svg";
import RootStore from "../../store/RootStore";
import { inject, observer } from "mobx-react";
import { formatCommentNumber } from "../../utils/util";
import stat from "../../utils/stat";
import useCarousel from "../ComponentCarousel/useCarousel";
import CarouselControlBtns from "../ComponentCarousel/CarouselControlBtns";
import activeGalleryInstance from '../GalleryList/ActiveGalleryInstance';
import { RenderEffect } from "../ComponentCarousel/AllForCarousel";
import { createPortal } from "react-dom";
import { IOneGallery } from "../GalleryList/Common";
import { pushHistory, popHistory } from "../../utils/history";
import usePerson from '../Followee/usePerson';
import { customizeCheckCanDownload } from '../../utils/customize';

//
export const getWxActiveIsOn = () => {
  const { active_on } = window.configDetail;
  //  0表示关闭, 不需要微信授权，
  //  1表示开启, 需要微信授权
  return Number(active_on);
}

//每张图片是64px(55px大小+2*2px边框+5px mr)
const SMALL_IMAGE_WH = 64;
const { downloadImage } = imageUtil;

interface IBigPic {
  currentImageIndex: number;
  list: any[]; // 后期完善
  total: number;
  setCurrentImageIndex: Dispatch<SetStateAction<number>>;
  hideBigPic: () => void;
  loadFinish: (index: number, size?: number) => void;
  loadError: (index: number) => void;
  loadPic: (params: any) => void;
  loadBigPic: () => void;
  onLongPress?: () => void;
  onZoomStart?: (index: number, params: any) => void;
  showBigPic: (params: { id: number; index: number }) => void;
  showComment: () => void;
  loveit: () => void;
  isLike?: boolean;
  commentTotal?: number;
  rootStore?: RootStore;
  currentPayGoodId?: number;
  currentPayWatermark?: string;
  currentIndexIsPayed?: boolean;
  printCurrentImage?: (args: any) => void;
  bigPicTopInfoRender?: React.ReactNode;
}

// 检测当前是否显示海报，主要是根据当前界面的挂件里，是否含有海报按钮
let pendentComponet = [] as IComponent[];
getPageSameType(window.pageDetail.template, pendentComponet, "pendent");

const isShowPoster = (() => {
  if (pendentComponet && pendentComponet.length) {
    let item = pendentComponet[0];
    if (item) {
      if (item.buttons && item.buttons.length) {
        for (var i = 0; i < item.buttons.length; i++) {
          if (item.buttons[i].type == "jigsaw") {
            if (item.api == "v2") {
              return true;
            } else if (item.buttons[i].show === true) {
              return true;
            }
          }
        }
      }
    }
  }

  return false;
})();

const BigPic = (props: IBigPic) => {
  const { currentImageIndex, list, currentPayWatermark, currentIndexIsPayed, currentPayGoodId } = props;
  const { danmakuSwitchOn, setDanmakuSwitchOn } = useDanmakuSwitch();
  const { use_comment, use_face } = window.configDetail;
  const bigPicElement = useRef<HTMLDivElement>(null);
  const { wxuserStore, relationStore, uiStore, galleryStore } = props.rootStore!;

  const setDanmakuSwitch = () => {
    setDanmakuSwitchOn((on) => !on);
  };

  // 关闭时解除所有的锁定，开启时锁定
  useEffect(() => {
    // console.log(bigPicElement, 'bigpic');
    const changeBodyScroll = (e: any) => {
      // console.log("change body Scroll", e);
      if (e && e.data) {
        if (bigPicElement && bigPicElement.current) {
          enableBodyScroll(bigPicElement.current);
        }
      } else {
        if (bigPicElement && bigPicElement.current) {
          disableBodyScroll(bigPicElement.current);
        }
      }
    };

    // if (bigPicElement && bigPicElement.current) {
    //   disableBodyScroll(bigPicElement.current);
    // }

    changeBodyScroll({
      data: false,
    });

    window.addEventListener("CHANGE_BODY_SCROLL", changeBodyScroll);

    return () => {
      if (bigPicElement && bigPicElement.current) {
        enableBodyScroll(bigPicElement.current);
      } else {
        clearAllBodyScrollLocks();
      }

      window.removeEventListener("CHANGE_BODY_SCROLL", changeBodyScroll);
    };
  }, []);

  const keyup = (e: { keyCode: number }) => {
    let targetIndex = currentImageIndex;
    if (e.keyCode == 37) {
      targetIndex = Math.max(0, targetIndex - 1);
    }
    if (e.keyCode == 39) {
      if (targetIndex === list.length - 1) {
        props.rootStore!.uiStore.showToast({
          content: intl.get("This is the last one photo"),
          time: 1000,
        });
      }
      targetIndex = Math.min(list.length - 1, targetIndex + 1);
    }
    var target = list[targetIndex];
    if (target && target.id) {
      props.showBigPic({
        index: targetIndex,
        id: target.id,
      });
    }
  };

  // 开启时注册keyup事件，销毁时取消掉
  useEffect(() => {
    (isWeb() || isWeixinWeb()) && window.addEventListener("keyup", keyup);
    return () => {
      window.removeEventListener("keyup", keyup);
    };
  }, [currentImageIndex]);

  const [activeAvatarIndex, setActiveAvatarIndex] = useState(0);

  // 切换图片时重置头像选中状态
  useEffect(() => {
    setActiveAvatarIndex(0);
  }, [currentImageIndex]);

  // const [personid, setPersonid] = useState(""); //当前点击项的personid
  // const [imageid, setImageid] = useState(""); // 当前电机箱的imageid
  const [personParams, setPersonParams] = useState({
    personid: "",
    imageid: ""
  } as {
    personid: string,
    imageid: string,
    faceurl?: string
  });
  const changeActiveAvatarIndex = (
    index: number,
    personid: string,
    imageid: string,
    faceurl?: string,
  ) => {
    index !== null && setActiveAvatarIndex(index);
    // setPersonid(personid);
    // setImageid(imageid);
    // setPersonParams({
    //   personid,
    //   imageid,
    //   faceurl
    // });

    stat.event("face_click");

    let visibleEvent = new Event("CHANGE_BODY_SCROLL");
    visibleEvent.data = true;
    window.dispatchEvent(visibleEvent);

    usePerson(relationStore, Number(personid), imageid, undefined, faceurl);
  };

  const onPersonClose = () => {
    setPersonParams({
      personid: "",
      imageid: "",
      faceurl: ""
    });

    let visibleEvent = new Event("CHANGE_BODY_SCROLL");
    visibleEvent.data = false;
    window.dispatchEvent(visibleEvent);
  }

  const [bigpicScrollShow, setBigPicScrollShow] = useState(true);

  const smallScrollChange = (e: React.UIEvent<HTMLDivElement>) => {
    const { target } = e;
    const { scrollLeft = 0, clientWidth = 0 } = (target ||
      {}) as HTMLDivElement;
    //console.log(target)
    const currentLastIndex = Math.floor(
      (scrollLeft + clientWidth) / SMALL_IMAGE_WH
    );
    // console.log(currentLastIndex, clientWidth);
    const { list, total } = props;
    // 本来应该严格地判断等于length-1但是实际操作中，期望的是提前几个就开始加载
    // 这个MORE 可以考虑后面修改，目前设定成一屏的个数
    const MORE = Math.max(Math.floor(clientWidth / SMALL_IMAGE_WH), 4);
    if (currentLastIndex >= list.length - 1 - MORE && list.length < total) {
      debounceGetList();
    }
  };

  const debounceGetList = debounce(() => {
    console.warn("get list");
    const { loadPic } = props;
    loadPic && loadPic({ uselasttime: true });
  }, 5000);

  // 小的滚动图
  const smallScrollEle = useRef<HTMLDivElement>(null);

  //add==true表示在原有滚动的基础上加上left的值；否则滚动到left的位置
  const smallScrollTo = (left: number, add = false) => {
    if (smallScrollEle && smallScrollEle.current) {
      if (add) {
        smallScrollEle.current.scrollLeft += left;
      } else {
        smallScrollEle.current.scrollLeft = left;
      }
    }
  };
  const smallScrollToByIndex = (index: number) => {
    smallScrollTo((index - 2) * SMALL_IMAGE_WH);
  };

  useEffect(() => {
    // console.log('big pic use effect', currentImageIndex);
    if (currentImageIndex !== -1 && currentImageIndex !== undefined) {
      smallScrollToByIndex(currentImageIndex);
    }
  }, [currentImageIndex]);

  //大图页显示的时候，隐藏掉Video
  useEffect(() => {
    window.dispatchEvent(new Event("hide-video"));
  }, []);
  // console.log(list[currentImageIndex]);

  const buildPoster = (one: IOneGallery) => {
    // 这玩意有点麻烦啊，还是直接发事件吧，哈哈哈哈
    let event = new Event("set-jigsaw-data");
    event.data = {
      type: "poster",
      ids: [one],
      from: "big-pic",
    };
    window.dispatchEvent(event);

    let changeEvent = new Event("CHANGE_BODY_SCROLL");
    changeEvent.data = true;
    window.dispatchEvent(changeEvent);
  };

  const [wrapperCls, setWrapperCls] = useState("bigpic");
  // 是否是PC端
  useEffect(() => {
    if (isWeb()) {
      setWrapperCls(classNames("bigpic", "pc"));
    }
  }, []);

  const checkCurrentWatermark = () => {
    const image = list[currentImageIndex];
    if (image && Number(image.show_mark)) {
      const imageSpecialGalleryWatermark = galleryStore.getWatermarksByKey(image?.galleryid);
      console.log(`checkCurrentWatermark`, imageSpecialGalleryWatermark);
      return imageSpecialGalleryWatermark || getWatermarks();
    }
    return [];
  };

  const [downloading, setDownloading] = useState(false);
  const downloadToast = (path: string, name: string) => {
    if (!downloading) {
      setDownloading(true);
      props.rootStore!.uiStore.showToast({
        content: intl.get("Downloading"),
        time: 0,
      });
      downloadImage(path, name).then(() => {
        props.rootStore!.uiStore.hideToast();
        setDownloading(false);
      });
    }
  };

  const downloadUrl =
    currentImageIndex !== -1
      ? imageUtil.style(
        list[currentImageIndex].hash,
        "original",
        { watermark: window.original_photo ? [] : checkCurrentWatermark() },
        list[currentImageIndex].id
      )
      : "";

  const toHide = function () {
    popHistory();
  };

  /**
   * 添加esc关闭功能
   */
  useEffect(() => {
    const esc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        toHide();
      }
    };
    window.addEventListener('keydown', esc);
    return () => {
      window.removeEventListener('keydown', esc);
    };
  }, []);

  const toHideHistory = function () {
    props.hideBigPic();
    clearAllBodyScrollLocks();
  };

  // 添加左滑关闭功能
  useEffect(() => {
    if (currentImageIndex > -1) {
      pushHistory('bigpic', () => {
        toHideHistory();
      });
    }
  }, [currentImageIndex > -1]);

  const { start, config, finalList, opShow, setTheConfig, toPlay, toPause } =
    useCarousel({
      rootStore: props.rootStore,
      list,
      loadMore: debounceGetList,
      index: currentImageIndex,
      setIndex: props.setCurrentImageIndex,
    });

  if (start) {
    return createPortal(
      <div className={"all-for-carousel"}>
        <RenderEffect
          config={config}
          images={finalList}
          index={currentImageIndex}
          setIndex={props.setCurrentImageIndex}
        />
        {opShow && (
          <>
            <div className={"bottom"}>
              <CarouselControlBtns
                simple={true}
                config={config}
                setTheConfig={setTheConfig}
                isPlaying={start}
                onStart={toPlay}
                onPause={toPause}
              />
            </div>
          </>
        )}
      </div>,
      document.body
    );
  }

  const canUseInherit = () => {
    if (currentPayWatermark) {
      return !!currentIndexIsPayed;
    }

    return true;
  };

  const checkUsePay = (callback: any) => {
    if (!canUseInherit()) {
      // 先检查是否登录
      if (wxuserStore.user.is_mock) {
        return wxuserStore.auth();
      }

      // 付费请求
      const image = list[currentImageIndex];
      if (image && image.id) {
        const notPayed = wxuserStore.getNotPayed([Number(image.id)]);
        // let notPayed = [id];
        if (notPayed && notPayed.length) {
          // 弹出付费
          const currentGalleryData = window.dataDetail ? window.dataDetail : window.gallery;
          uiStore.showToast({ content: intl.get("ReadyToPay") });
          wxuserStore.payToImage(currentGalleryData.id, Number(currentPayGoodId), window.pageDetail.link_id, notPayed).then((res: any) => {
            // 重新检查一下是否含有当前照片
            const realPayed = wxuserStore.getNotPayed([Number(image.id)]);
            if (realPayed && realPayed.length == 0) {
              callback && callback();
            }
          });
        }
      }
    }
    else {
      callback && callback();
    }
  };

  const canShowBigPicSlider = () => {
    if (isWeb()) {
      if (!currentPayGoodId) {
        return true;
      }
    }

    return false;
  }

  const checkBigPic = () => {
    if (!canUseInherit()) {
      return intl.get('PayToRemove');
    }
    else {
      return (list[currentImageIndex].loadStatus === "loading"
        ? intl.get("Loading")
        : intl.get("Full image")) + formatSize(list[currentImageIndex].size);
    }
  }

  return (
    <div className={wrapperCls} ref={bigPicElement}
    // onClick={toHide}
    >
      {danmakuSwitchOn && use_comment * 1 ? <Danmaku /> : null}
      <img
        src={require("../../assets/big-pic-arrow-left.png")}
        alt=""
        className={classNames("control control-left")}
        onClick={(e) => {
          e.stopPropagation();
          keyup({ keyCode: 37 });
        }}
      />
      <img
        src={require("../../assets/big-pic-arrow-right.png")}
        alt=""
        className={classNames("control control-right")}
        onClick={(e) => {
          e.stopPropagation();
          keyup({ keyCode: 39 });
        }}
      />
      <BigPicMain {...props} mode={activeGalleryInstance.get()?.mode || '1'} />
      <div
        className={classNames("bigpic-wrapper")}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="top-big-pic">
          <BigPicHeader
            detail={list[currentImageIndex]}
            currentImageIndex={currentImageIndex}
            count={props.total}
          >
            {use_comment * 1 ? (
              <div
                style={{ fontSize: 12, display: "flex", alignItems: "center" }}
              >
                <div style={{ marginLeft: 4, marginRight: 2 }}>
                  {intl.get("Bullet screen")}
                </div>
                <Switch on={danmakuSwitchOn} onClick={setDanmakuSwitch} />
              </div>
            ) : null}
          </BigPicHeader>
          <div className="bigpic-operation">
            {canShowBigPicSlider() ? (
              <img
                className="bigpic-slider-play"
                src={require("../../assets/slider-play.png")}
                alt=""
                onClick={toPlay}
              />
            ) : null}
            <img
              src={require("../../assets/x-circle.png")}
              alt=""
              className="bigpic-close position-big-pic"
              onClick={toHide}
            />
          </div>
        </div>

        {/*随意写一个高度试试，IOS上显示有问题，不明为什么*/}
        <div style={{ flex: 1, zIndex: -1, height: 100 }} />
        <div className={"bottom-big-pic"}>
          {props.bigPicTopInfoRender ? (
            <div className="bigpic-bottom-top-row">{props.bigPicTopInfoRender}</div>
          ) : null}
          {+use_face ? (
            !list[currentImageIndex]?.maybe?.length ? null : (
              <div className={"maybe-list-wrapper"} key={list[currentImageIndex].id}>
                <div className="maybe-list someone-list">
                  {list[currentImageIndex]?.maybe.map(
                    (maybe: IImageMayBe, index: number) => (
                      <MayBeOneImg
                        key={maybe.personid}
                        maybe={maybe}
                        onClick={(faceurl?: string) => {
                          changeActiveAvatarIndex(
                            index,
                            maybe.personid,
                            maybe.imageid,
                            faceurl
                          );
                        }}
                        active={activeAvatarIndex === index}
                      />
                    )
                  )}
                </div>
                <div className="tip-row">
                  <span style={{ color: "#4EC8BF", marginRight: 5 }}>
                    {intl.get("Click portrait")}
                  </span>
                  {intl.get("to find more of him/her")}
                </div>
              </div>
            )
          ) : (
            <div
              className="bigpic-scroll-row"
              // 注意，必须得阻止掉touchStart（可以在更外层），否则这个事件冒泡到顶层被接收后可能会触发整个MainTab的滑动（如果没有的话什么都不会发生）
              // 从而导致下面的.small-scroll-wrapper的滑动失败
              onTouchStart={(e) => e.stopPropagation()}
            >
              {/*<!-- 注意显示的时候 文字应该用“隐藏” -->*/}
              <div
                className="bigpic-scroll-hide"
                onClick={() => setBigPicScrollShow((prevState) => !prevState)}
              >
                {bigpicScrollShow ? intl.get("hide") : intl.get("show")}
              </div>

              {bigpicScrollShow && (
                <div
                  className={"small-scroll-wrapper"}
                  onScroll={smallScrollChange}
                  ref={smallScrollEle}
                >
                  {list?.length &&
                    list.map((one, index) => {
                      return (
                        <div
                          key={one.id}
                          className={`bigpic-image-wrapper ${index === currentImageIndex ? "active" : ""
                            }`}
                        >
                          <LazyLoad
                            height={55}
                            scrollContainer={".small-scroll-wrapper"}
                            overflow={true}
                            once
                          >
                            <div
                              className={"image-zoom-container"}
                              style={{
                                width: 55,
                                height: 55,
                                backgroundImage: `url(${imageUtil.style(
                                  one["hash"],
                                  "wx_250_160",
                                  { watermark: checkCurrentWatermark() },
                                  one.id
                                )})`,
                                backgroundSize: "cover",
                                backgroundPosition: "top center",
                              }}
                              onClick={props.showBigPic.bind(null, {
                                index,
                                id: one.id,
                              })}
                              data-index={index}
                            />
                          </LazyLoad>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          )}
          <div className="bigpic-bottom">
            <div className="bigpic-bottom-info-wrapper">
              {list[currentImageIndex].loadStatus === "loaded" ? (
                <div className="big-pic-info">
                  <span>{intl.get("Loaded") + " "}</span>
                </div>
              ) : (
                <span onClick={async () => {
                  const [error, canDownload] = await customizeCheckCanDownload(list[currentImageIndex].id, props.rootStore?.uiStore);
                  if (!error && canDownload) {
                    checkUsePay(() => {
                      //  src/components/BigPic/AllForBigPic.tsx:276
                      props.loadBigPic && props.loadBigPic();
                    })
                  }
                }} className="big-pic-info">
                  {checkBigPic()}
                </span>
              )}

              {isShowPoster ? (
                <span
                  className="big-pic-info"
                  data-stat="P_Poster_BigPic"
                  onClick={async () => {
                    const [error, canDownload] = await customizeCheckCanDownload(list[currentImageIndex].id, props.rootStore?.uiStore);
                    if (!error && canDownload) {
                      checkUsePay(() => {
                        buildPoster(list[currentImageIndex]);
                      })
                    }
                  }}
                >
                  {intl.get("BigPicPoster")}
                </span>
              ) : null}

              {isWeb() && <span
                className="big-pic-info"
                data-stat="P_Print"
                onClick={async () => {
                  //  只有微信授权开启并且没有登录才需要登录
                  if (getWxActiveIsOn() && wxuserStore.user.is_mock) {
                    return wxuserStore.auth();
                  }

                  const [error, canDownload] = await customizeCheckCanDownload(list[currentImageIndex].id, props.rootStore?.uiStore);
                  if (!error && canDownload) {
                    checkUsePay(() => {
                      props.printCurrentImage && props.printCurrentImage(currentImageIndex);
                    });
                  }

                  // props.printCurrentImage && props.printCurrentImage(currentImageIndex);
                }}
              >
                {intl.get("PrintCurrentImage")}
              </span>}


              {!window.isweixin &&
                !window.isweixinweb &&
                Number(window.configDetail.active_on) &&
                window.screen.availWidth > 750 ? (
                <span
                  className="big-pic-info"
                  onClick={async () => {
                    if (wxuserStore.user.is_mock) {
                      return wxuserStore.auth();
                    }

                    const [error, canDownload] = await customizeCheckCanDownload(list[currentImageIndex].id, props.rootStore?.uiStore);
                    if (!error && canDownload) {
                      checkUsePay(() => {
                        downloadToast(
                          downloadUrl,
                          list[currentImageIndex].origin ||
                          `Bigpic${list[currentImageIndex].id}.jpg`
                        );
                      });
                    }
                  }}
                >
                  {intl.get("Download")}
                </span>
              ) : null}
            </div>
            <div style={{ flex: 1 }} />
            {!wxuserStore.user.is_mock ? (
              <>
                {Number(use_comment) ? (
                  <div onClick={props.showComment} className={"icon"}>
                    <ReactSVG
                      src={require("../../svg/icon-edit.svg")}
                      className={"icon-normal"}
                    />
                    {props.commentTotal ? (
                      <div className="numbers">
                        <span className={"small-number"}>
                          {formatCommentNumber(props.commentTotal)}
                        </span>
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </>
            ) : null}
            <div onClick={() => {
              checkUsePay(() => {
                props.loveit && props.loveit();
              })
            }} className={"icon"}>
              {props.isLike ? (
                <ReactSVG
                  src={require("../../svg/heart-red.svg")}
                  className={"icon-heart-red"}
                />
              ) : (
                <ReactSVG
                  src={require("../../svg/heart.svg")}
                  className={"icon-normal"}
                />
              )}
              {(list[currentImageIndex] && Number(list[currentImageIndex].love) > 0) ? <span className="numbers circle">
                {Number(list[currentImageIndex].love)}
              </span> : null}
            </div>
            <div
              className="icon"
              style={{ marginRight: 15 }}
              onClick={() => props.setCurrentImageIndex(currentImageIndex + 1)}
            >
              <ReactSVG
                src={require("../../svg/right-arrow.svg")}
                className={"icon-normal icon-right-arrow2"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default inject("rootStore")(observer(BigPic));
